import { defineFcm } from '../shared/factory';

export const FCM_CORGI_REQUEST_PROVIDER_COALESCING_ENABLED = defineFcm('corgi_request_provider_coalescing_enabled')
	.asBoolean()
	.withDefault(false) // ship dark: enable via admin once the deploy is confirmed healthy
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'middle-end (RequestProvider)',
		description: `Enables in-flight request coalescing ("single-flight") for cached GET requests in
		requestProvider/serviceRequestProvider.

		When enabled, concurrent cache misses for the same cache key share a single backend request
		instead of each issuing their own. This bounds duplicate backend calls to roughly one per key
		per pod, rather than one per concurrent request.

		Only affects requests that pass cacheLifetimeSeconds. Disable to restore the previous
		behaviour (every cache miss issues its own request).

		Safe to toggle at any time: flipping it off does not invalidate anything, it only stops new
		callers from sharing a request.

		⚠️ Only global group is supported.`,
	});
